import api from "./api";



const createOrchestrator = (orchestrator) => {
  return api.post("/orchestrator", {
    ...orchestrator
  })
  .then((response) => {
    return response.data;
  });
};

const updateOrchestrator = (org) => {
  return api.patch("/orchestrator",
  {
    ...org
  })
  .then((response) => {
    return response.data;
  });
};

const deleteOrchestrator = (id) => {
  return api.delete("/orchestrator/" + id)
  .then((response) => {
    return response.data;
  });
};





const getOrchestrators = (search) => {

  return api.get("/orchestrator",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getOrchestrator = (id) => {
  return api.get("/orchestrator/"+id)
  .then((response) => {
    return response.data;
  });
};

const getThisOrchestrator = () => {
  return api.get("/orchestrator/this")
  .then((response) => {
    return response.data;
  });
};

const getAvailableTenants = (organization, currentOrchestratorId = null) => {
  // Show all tenants since we now support multiple orchestrators per tenant
  // No filter needed - all tenants can be selected
  return api.get("/dimensions", {
    params: {
      type: "stateSet",
      implementor: "Tenant",
      field: "_id",
      lookUpLabel: "<tenant_name>"
    }
  })
  .then((response) => {
    // Convert dimension values response to tenant options format
    const lookUpLabels = response.data.lookUpLabels || [];
    const tenants = lookUpLabels.map(item => ({
      id: item.value,
      name: item.label || item.value
    }));
    return { tenants };
  });
};


const OrchestratorSevice = {
  getOrchestrators,
  createOrchestrator,
  updateOrchestrator,
  deleteOrchestrator,
  getOrchestrator,
  getThisOrchestrator,
  getAvailableTenants,
};

export default OrchestratorSevice;